const metaItemActive = {
  itemActive: 'Reports',
};
export default [
  {
    path: '/reports',
    name: 'Reports',
    component: () => import('Support/layout/CrudListTemplate.vue'),
    meta: {
      itemActive: 'Reports',
      crud: {
        pageTitle: 'app.reports.title',
        pageContent: () => import('App/reports/ReportList.vue'),
        filterDialogComponent: () => import('App/reports/components/ReportFilterList.vue'),
        anyComponent: () => import('App/reports/components/ReportListUpdateButton.vue'),
        anyComponent1: () => import('App/reports/components/ReportTotalList.vue'),
      },
    },
  },
  {
    path: '/reports/inadimplentes',
    name: 'InadimplentesReport',
    component: () => import('App/reports/InadimplentesReport.vue'),
    meta: metaItemActive,
  },
  {
    path: '/reports/comissoes',
    name: 'ComissoesReport',
    component: () => import('App/reports/ComissoesReport.vue'),
    meta: metaItemActive,
  },
  {
    path: '/reports/contratacoes',
    name: 'ContratacoesReport',
    component: () => import('App/reports/ContratacoesReport.vue'),
    meta: metaItemActive,
  },
  {
    path: '/reports/projecoes',
    name: 'ProjecoesReport',
    component: () => import('App/reports/ProjecoesReport.vue'),
    meta: metaItemActive,
  },
  {
    path: '/reports/recebiveis',
    name: 'RecebiveisReport',
    component: () => import('App/reports/RecebiveisReport.vue'),
    meta: metaItemActive,
  },
];
